import type {ReactElement} from 'react';
import {getPmwLogoUrl} from '@Utils/logo.util';
import {isUserLoggedIn} from '@Libraries/user.library';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import type {EmailMakerNavLogoProps} from './email-maker-nav-logo.types';
import styles from './email-maker-nav-logo.module.scss';

function resolveLogoSrc(editorViewport: EditorViewport): string {
  const showFullLogo = editorViewport === EditorViewport.DESKTOP;
  return getPmwLogoUrl(showFullLogo);
}

function resolveLogoHref(): string {
  if (isUserLoggedIn()) {
    return window.PMW.util.site_url('posters/mine#/email-marketing-campaigns');
  }

  return window.PMW.util.site_url('');
}

export function EmailMakerNavLogo({editorViewport}: EmailMakerNavLogoProps): ReactElement {
  return (
    <div className={styles.logoContainer}>
      <a className={styles.logoLink} href={resolveLogoHref()} aria-label={window.i18next.t('pmwjs_form_maker_go_to_home')}>
        <img className={styles.logoImg} src={resolveLogoSrc(editorViewport)} alt="PosterMyWall" />
      </a>
    </div>
  );
}
